import { supabase } from './supabaseClient';

export async function signup(email, password, firstName, lastName) {
  const { user, session, error } = await supabase.auth.signUp(
    { email, password },
    { data: { firstName, lastName } }
  );
  if (error) throw new Error(error.message);
  return { user, session };
}

export async function login(email, password) {
  const { user, session, error } = await supabase.auth.signIn({ email, password });
  if (error) throw new Error(error.message);
  return { user, session };
}

export async function logout() {
  const { error } = await supabase.auth.signOut();
  if (error) throw new Error(error.message);
}
